import React, { PureComponent } from 'react';

import BannerLayout from '../../layouts/banner';

import Image from '../../../../../containers/assets/share-buyback.png'

class ShareBuybacks extends PureComponent {
  render() {
    const { previousShownErrors } = this.props;

    return (
      <BannerLayout
        section="What to expect next"
        subSection="Share Buybacks"
        alertText="Share Buyback"
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <p>Teams will also have to decide if they should re-invest their capital back into the business or return the capital to investors through <a href="https://www.mindtools.com/pages/article/newTMC_90.htm" target="_blank" rel="noreferrer">share buybacks.</a></p>
        )}
        visual={(
          <img src={Image} alt="" />
        )
        }
        visualProps={{
          noBorder: true,
          noBackground: true
        }}
      />
    );
  }
}

export default ShareBuybacks;


// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/what-to-expect-next/share-buybacks.js